var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.468v13.064a.11.11 0 0 0 .019.066c.015.025.05.062.11.096.126.069.286.078.429.005l12.802-6.532a.283.283 0 0 0 .12-.099.13.13 0 0 0 0-.136.283.283 0 0 0-.12-.099L6.558 5.301a.456.456 0 0 0-.429.005.303.303 0 0 0-.11.096.11.11 0 0 0-.019.066Zm-1.5 0v13.064c0 1.305 1.508 2.132 2.74 1.503l12.802-6.532c1.277-.652 1.277-2.354 0-3.006L7.24 3.965c-1.232-.629-2.74.198-2.74 1.503Z"
  })));
};
export default SvgPlay;